import { useNavigationStore } from '@/features/navigation/store/navigation-store';
import { findAndFocusElement } from '@/features/navigation/utils/find-and-focus-element';

const setCategoryId = useNavigationStore.getState().setCategoryId;
const setSubcategoryId = useNavigationStore.getState().setSubcategoryId;
const resetAll = useNavigationStore.getState().resetAll;

export const handleEscape = (e: KeyboardEvent, isDesktop: boolean) => {
  const categoryId = useNavigationStore.getState().categoryId;

  if (!isDesktop || !categoryId) return;

  e.preventDefault();
  resetAll();
  findAndFocusElement(`[data-header-button-focus-id="${categoryId}"]`);
};

export const handleArrowDown = (
  e: KeyboardEvent,
  isDesktop: boolean,
  focusNext: () => void,
) => {
  if (!isDesktop) return;
  const categoryId = useNavigationStore.getState().categoryId;

  const focusedElement = e.target;

  if (!(focusedElement instanceof HTMLElement)) return;

  if (focusedElement.getAttribute('data-subcategory-last-item') === 'true') {
    e.preventDefault();
    findAndFocusElement('[data-subcategory-first-item="true"]');

    return;
  }

  if (focusedElement.getAttribute('data-category-last-item') === 'true') {
    e.preventDefault();
    findAndFocusElement('[data-category-first-item="true"]');

    return;
  }

  const focusedElementId = Number(
    focusedElement.getAttribute('data-header-button-focus-id'),
  );

  if (focusedElementId && categoryId !== focusedElementId) {
    e.preventDefault();
    setCategoryId(focusedElementId);
    setSubcategoryId(null);

    return;
  }

  if (categoryId) {
    e.preventDefault();
    focusNext();

    return;
  }
};

export const handleArrowUp = (
  e: KeyboardEvent,
  isDesktop: boolean,
  focusPrev: () => void,
) => {
  const categoryId = useNavigationStore.getState().categoryId;

  if (!isDesktop || !categoryId) return;

  const focusedElement = e.target;

  if (!(focusedElement instanceof HTMLElement)) return;

  if (focusedElement.getAttribute('data-subcategory-first-item') === 'true') {
    e.preventDefault();
    findAndFocusElement('[data-subcategory-last-item="true"]');

    return;
  }
  if (focusedElement.getAttribute('data-category-first-item') === 'true') {
    e.preventDefault();
    findAndFocusElement('[data-category-last-item="true"]');

    return;
  }

  const focusedElementId = Number(
    focusedElement.getAttribute('data-header-button-focus-id'),
  );

  if (focusedElementId) {
    e.preventDefault();
    setSubcategoryId(null);
    setCategoryId(null);

    return;
  }

  e.preventDefault();
  focusPrev();
};
